module.exports = __webpack_public_path__ + "img/7fb8f72.png";